import { Player } from "@lottiefiles/react-lottie-player"

const cards = [
  {
    label: "AI Support",
    video: null,
    lottie: "/gifs/Ai.json",
    heading: "AI-Powered Hiring",
    description:
      "Create vacancies, screen candidates and generate interview questions automatically with our built-in AI assistant.",
    highlights: ["AI vacancy creation", "Smart candidate screening", "AI interview questions"],
    accent: "from-[#1A237E] to-cyan-400",
  },
  {
    label: "Recruitment",
    video: null,
    lottie: "/gifs/Recruitment.json",
    heading: "End-to-End Recruitment",
    description:
      "Manage your full hiring pipeline — post jobs, track applicants, schedule interviews and send offers all in one place.",
    highlights: ["Multi-platform job posting", "Applicant tracking", "Video interviews"],
    accent: "from-cyan-400 to-[#1A237E]",
  },
  {
    label: "Onboarding",
    video: null,
    lottie: "/gifs/Onboarding.json",
    heading: "Seamless Onboarding",
    description:
      "Onboard new hires with automated workflows, digital document collection and welcome videos — less admin, faster starts.",
    highlights: ["Automated workflows", "Digital documents", "Welcome video support"],
    accent: "from-[#1A237E] to-cyan-400",
  },
]

export default function ShowcaseSection() {
  return (
    <section id="showcase" className="py-24 bg-background">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {/* Heading */}
        <div className="mx-auto max-w-3xl text-center mb-16">
          <p className="text-md font-bold text-cyan-500 uppercase tracking-widest mb-3">
            Everything in one platform
          </p>
          <h2 className="text-4xl sm:text-5xl font-bold text-foreground">
            Built for modern hiring teams
          </h2>
          <p className="mt-4 text-base text-muted-foreground">
            From AI-powered tools to full recruitment and onboarding — see how
            Tempered Talent transforms your workflow.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          {cards.map((card) => (
            <div
              key={card.label}
              className="relative rounded-2xl border border-border bg-[#f7f8fd] overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-200 flex flex-col"
            >
              {/* Video / Lottie */}
              <div className="w-full bg-card">
                {card.lottie ? (
                  <Player
                    autoplay
                    loop
                    src={card.lottie}
                    className="w-full h-48"
                  />
                ) : (
                  <video
                    src={card.video!}
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="w-full h-48 object-cover"
                  />
                )}
              </div>

              {/* Content */}
              <div className="p-8 flex flex-col flex-1">
                <h3 className="text-lg font-semibold text-foreground mb-3">
                  {card.heading}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed mb-6">
                  {card.description}
                </p>
                <ul className="space-y-2 mt-auto">
                  {card.highlights.map((point) => (
                    <li key={point} className="flex items-center gap-3 text-sm text-foreground">
                      <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cyan-400/20">
                        <span className="h-2 w-2 rounded-full bg-cyan-500" />
                      </span>
                      {point}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Bottom accent */}
              <div className={`h-1 w-full bg-gradient-to-r ${card.accent}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
